import { useInvestigationUrlSync } from '@/features/investigations/hooks/useInvestigationUrlSync'
import { GeolocationView } from '@/pages/geolocation/geolocation-view'
import { useCaseContext } from '../../CaseContext'

export default function InvestigateGeolocationPage() {
  const { caseId } = useCaseContext()
  useInvestigationUrlSync()
  return (
    <div className="h-full">
      {/* Keyed on caseId so the map remounts cleanly on case switch. NOT
          keyed on `location.key`: the URL-sync hook rewrites
          ?investigation=... via replaceState whenever the active
          investigation changes, which would otherwise force a full
          remount and a visible double-blink on every landing. */}
      <GeolocationView key={caseId} caseId={caseId} />
    </div>
  )
}
